function parseDelimitedLine(line, delimiter) {
  const cells = [];
  let current = "";
  let index = 0;
  let inQuotes = false;

  while (index < line.length) {
    const character = line[index];

    if (character === "\"") {
      if (inQuotes && line[index + 1] === "\"") {
        current += "\"";
        index += 2;
        continue;
      }

      inQuotes = !inQuotes;
      index += 1;
      continue;
    }

    if (character === delimiter && !inQuotes) {
      cells.push(current);
      current = "";
      index += 1;
      continue;
    }

    current += character;
    index += 1;
  }

  cells.push(current);
  return cells;
}

function countDelimitedSeparators(line, delimiter) {
  let count = 0;
  let inQuotes = false;

  for (let index = 0; index < line.length; index += 1) {
    const character = line[index];

    if (character === "\"") {
      if (inQuotes && line[index + 1] === "\"") {
        index += 1;
        continue;
      }

      inQuotes = !inQuotes;
      continue;
    }

    if (character === delimiter && !inQuotes) {
      count += 1;
    }
  }

  return count;
}

function detectDelimitedTextSeparator(text) {
  const normalizedText = String(text ?? "").replace(/\r\n?/g, "\n").replace(/^\uFEFF/, "");
  const firstNonEmptyLine = normalizedText
    .split("\n")
    .map((line) => line.trimEnd())
    .find((line) => line.trim().length > 0);

  if (!firstNonEmptyLine) {
    return ",";
  }

  const tabCount = countDelimitedSeparators(firstNonEmptyLine, "\t");
  const commaCount = countDelimitedSeparators(firstNonEmptyLine, ",");

  return tabCount > commaCount ? "\t" : ",";
}

export function parseCsvText(text, delimiter = detectDelimitedTextSeparator(text)) {
  const normalizedText = String(text ?? "").replace(/\r\n?/g, "\n").replace(/^\uFEFF/, "");
  const lines = normalizedText
    .split("\n")
    .map((line) => line.trimEnd())
    .filter((line) => line.trim().length > 0);

  if (lines.length === 0) {
    return [];
  }

  return lines.map((line) => parseDelimitedLine(line, delimiter));
}

export function normalizeCsvHeader(header) {
  return String(header ?? "")
    .trim()
    .toLocaleLowerCase();
}
